"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles_1 = require("@mui/material/styles");
var Avatar_1 = require("@mui/material/Avatar");
var Typography_1 = require("@mui/material/Typography");
var material_1 = require("@mui/material");
var IconButton_1 = require("@mui/material/IconButton");
var ListItem_1 = require("@mui/material/ListItem");
var ListItemText_1 = require("@mui/material/ListItemText");
var ListItemAvatar_1 = require("@mui/material/ListItemAvatar");
var ExpandMore_1 = require("@mui/icons-material/ExpandMore");
var CommonFunctions_1 = require("../shared/utilities/CommonFunctions");
var ExpandMore = styles_1.styled(function (props) {
    var expand = props.expand, other = __rest(props, ["expand"]);
    return React.createElement(IconButton_1.default, __assign({}, other));
})(function (_a) {
    var theme = _a.theme, expand = _a.expand;
    return ({
        transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    });
});
function Suggestion(props) {
    var _a = React.useState(false), expanded = _a[0], setExpanded = _a[1];
    var _b = React.useState(props.isRead), isRead = _b[0], setIsRead = _b[1];
    var _c = React.useState(false), loadCompleted = _c[0], setLoadCompleted = _c[1];
    var handleExpandClick = function () {
        setExpanded(!expanded);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ListItem_1.default, { alignItems: "flex-start", style: { cursor: 'pointer' }, secondaryAction: React.createElement(ExpandMore, { expand: expanded, onClick: handleExpandClick, "aria-expanded": expanded, "aria-label": "show more" },
                React.createElement(ExpandMore_1.default, null)) },
            React.createElement(material_1.ListItemIcon, null,
                React.createElement(material_1.Checkbox, { edge: "start", checked: isRead, onChange: function (e) {
                        setIsRead(e.target.checked);
                        props.handleIsReadChanged(props.id, e.target.checked);
                    }, tabIndex: -1, disableRipple: true })),
            React.createElement(ListItemAvatar_1.default, { onClick: handleExpandClick },
                React.createElement(Avatar_1.default, null,
                    " ",
                    CommonFunctions_1.default.getNameAbbreviation(props.firstName, props.lastName),
                    " ")),
            React.createElement(ListItemText_1.default, { onClick: handleExpandClick, primary: React.createElement(React.Fragment, null,
                    React.createElement(Typography_1.default, { sx: { display: 'inline' }, component: "span", variant: "body2", color: "text.primary" },
                        props.firstName + " " + props.lastName,
                        " ",
                        React.createElement("br", null),
                        " ",
                        props.title)), secondary: React.createElement(React.Fragment, null,
                    React.createElement(Typography_1.default, { variant: "body2", component: "pre", style: { whiteSpace: 'pre-wrap', wordWrap: 'break-word' }, className: expanded ? "" : "typographyNoOverflow" },
                        props.body,
                        React.createElement("br", null),
                        props.documentLocation !== '' && props.documentLocation !== null &&
                            React.createElement("a", { href: props.documentLocation, download: true }, "View"))) })),
        React.createElement(material_1.Divider, { variant: "inset", component: "li" })));
}
exports.default = Suggestion;
//# sourceMappingURL=Suggestion.js.map